export const statuses = [
    {'Re-Opened': '#FFE133'},
    {'Waiting_On_ActZero': '#d0f31b'},
    {'Waiting_On_Customer': '#FFA415'},
    {'Resolved': '#018D8D'},
    {'Merged': '#018D8D'},
    {'Closed': '#018D8D'}
  ]